<template>
  <v-row>
    <v-col
      cols="12"
      xl="2"
      lg="3"
      md="4"
      sm="6"
      xs="12"
      v-for="(item, index) in 6"
      :key="index"
    >
      <template>
        <v-sheet
          color="grey lighten-4"
          class="pa-0"
        >
          <v-skeleton-loader
            class="mx-auto"
            type="card, article"
          ></v-skeleton-loader>
        </v-sheet>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ArticleSkeletonLayout",
};
</script>